export { default } from "/Users/spencer/Projects/spencer-homepage/app/routes/index.tsx";